import { EventType } from './event-type.interface';

export const SECURITY_SYSTEM: EventType = {
  name: 'Security System',
  description: 'When a security system state changes',
  route: 'security',
  category: 'Security & Access',
  icon: 'security',
  whitelist: [
    {
      proxy: 'security',
      events: Array.apply(null, { length: 100 }).map(Number.call, Number)
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/security-system.type.ts